import { render, staticRenderFns } from "./SurveyPopup.vue?vue&type=template&id=152352a2&"
import script from "./SurveyPopup.vue?vue&type=script&lang=js&"
export * from "./SurveyPopup.vue?vue&type=script&lang=js&"
import style0 from "./SurveyPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports